import { render, staticRenderFns } from "./costInfo.vue?vue&type=template&id=38137c12&scoped=true&"
import script from "./costInfo.vue?vue&type=script&lang=js&"
export * from "./costInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38137c12",
  null
  
)

export default component.exports